import React from "react";
import Greeting from "@irati/ui/src/Greeting/Greeting";
import { H4 } from "@irati/ui/src/Typography";
import authentication from "@irati/auth";
import { StyledGreeting } from "./styled";
var HomePageGreeting = function () {
    var user = authentication.user();
    return (React.createElement(StyledGreeting, null,
        React.createElement(H4, null,
            React.createElement(Greeting, { user: user }))));
};
export default HomePageGreeting;
